// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5vWt_","name":"styles_name__2aX2-","phone":"styles_phone__2z1bi"};